import { render, staticRenderFns } from "./ParametrizacaoContratoPasso3.vue?vue&type=template&id=2aa53fa6&lang=html"
import script from "./ParametrizacaoContratoPasso3.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoContratoPasso3.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacaoContratoPasso3.vue?vue&type=style&index=0&id=2aa53fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports